<template>
    <div>
        <div class="search-top">
            <!-- <span>快币类型</span>
            <el-select class="top-choose" v-model="search.type">
                <el-option v-for="item in currencyList" :key="item.id" :value="item.id" :label="item.currency_name">
                </el-option>
            </el-select> -->
            <span>时间</span>
            <el-date-picker class="top-choose" v-model="search.start_date" type="date" placeholder="选择日期" :picker-options="picker_special">
			</el-date-picker>
            <small>~</small>
            <el-date-picker class="top-choose" v-model="search.end_date" type="date" placeholder="选择日期" :picker-options="picker_special">
			</el-date-picker>
            <div class="back-btn blue" @click="searchClick()">查询</div>
        </div>

        <div class="back-list search">
            <div class="list-head">
                <div>日期</div>
                <!-- <div>快币类型</div> -->
                <div>奖金收支({{ task_curr.currency_name }})</div>
                <div>奖金余额({{ task_curr.currency_name }})</div>
                <div>详情</div>
            </div>
            <z-scrollDiv class="main">
                <div class="list-item" v-for="item in dataList" :key="item.id">
                    <div>{{ item.bill_time | justDate }}</div>
                    <!-- <div>{{ item.currency_name }}</div> -->
                    <div :class="{add:item.bill_type == 1,reduce:item.bill_type!=1}">{{ item.trans_amount && (item.bill_type==1?"+":"-")+item.trans_amount }}</div>
                    <div>{{ item.balance }}</div>
                    <div class="overhide">{{ item.remark }}</div>
                </div>
                <z-noData :list="dataList"></z-noData>
            </z-scrollDiv>
        </div>

        <el-pagination
            @current-change="searchClick"
            :current-page.sync="data.current_page"
            :total="data.total"
            :page-size="data.per_page"
            layout="prev, pager, next, jumper"
        ></el-pagination>

    </div>
</template>

<script>
    import { mapState,mapGetters } from 'vuex'

    export default {
        props:['index','buId'],
        data(){
            return {
                search:{
                    type:"",
                    start_date:"",
                    end_date:"",
                },
                currencyArr:[],

                data:{},
            }
        },
        computed:{
            ...mapState(["picker_special",'currencyList']),
            ...mapGetters(['task_curr']),
            dataList(){
                return this.data.list;
            },

        },
        created(){
            this.$func.getCurrencyList();
            this.fresh(this.index);
        },

        watch:{
            index(val){
                this.fresh(val);
            }
        },

        methods:{
            fresh(index){  // 拉数据判断
                if(index == 2){
                    this.searchClick(this.data.current_page);
                }
            },
            getData(obj={}){
                let url =`api/admin/bu/currdetail`;
                obj.bu_id = this.buId;
                this.$http.get(url,{params:obj}).then(res=>{
                    if(res.status == 200){
                        this.data = res.res_data;
                    }
                });
            },
            searchClick(page){  //查询
                let obj = {
                    page:page,
                    currency_id:this.search.type,
                    start_date:this.search.start_date,
                    end_date:this.search.end_date,
                }
                this.getData(obj);
            }
        },
    }
</script>

<style lang="less" scoped>

    .list-head,.list-item{
        >div:nth-of-type(1){
            width: 20%;
        }
        >div:nth-of-type(2){
            width: 20%;
        }
        >div:nth-of-type(3){
            width: 20%;
        }
        >div:last-of-type{
            width: 40%;
        }
        .add{
            color:#34b96c;
            // color:#43a2ff;
        }
        .reduce{
            color:#ff8383;
        }
    }
</style>





// WEBPACK FOOTER //
// detail-bonus.vue?e9240386